import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { CartProvider } from './contexts/CartContext';
import { AuthProvider } from './AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import './App.css';
import './components/crossfade-splide.css'

// Import page components
import HomePage from './components/pages/HomePage';
import AuthPage from './components/pages/AuthPage';
import RecordingPage from './components/pages/RecordingPage';
import LabsPage from './components/pages/LabsPage';
import HirePage from './components/pages/HirePage';
import EventsPage from './components/pages/EventsPage';
import AccommodationPage from './components/pages/AccommodationPage';
import ShopPage from './components/pages/ShopPage';
import CartPage from './components/pages/CartPage';
import CheckoutPage from './components/pages/CheckoutPage';
import OrderSuccessPage from './components/pages/OrderSuccessPage';

// Import dropdown page components
import MusicEventsPage from './components/pages/MusicEventsPage';
import FoodEventsPage from './components/pages/FoodEventsPage';
import UpcomingPage from './components/pages/UpcomingPage';
import ArchivePage from './components/pages/ArchivePage';
import ContactPage from './components/pages/ContactPage';
import AdminPage from './components/pages/AdminPage';
import AdminSetup from './components/AdminSetup';
import MembershipPage from './components/pages/MembershipPage';
import MembershipCheckout from './components/pages/MembershipCheckout';
import MembershipSuccess from './components/pages/MembershipSuccess';
import MemberDashboard from './components/pages/MemberDashboard';
import EventDetailPage from './components/pages/EventDetailPage';
import ProductDetailPage from './components/pages/ProductDetailPage';
import PrivacyPolicyPage from './components/pages/PrivacyPolicyPage';
import TermsOfSalePage from './components/pages/TermsOfSalePage';
import CookiesPage from './components/pages/CookiesPage';
import TicketValidatorPage from './components/pages/TicketValidatorPage';
import TicketTestPage from './components/pages/TicketTestPage';
import TestIframePage from './components/pages/TestIframePage';
import TestEmbedPage from './components/pages/TestEmbedPage';
import NotFoundPage from './components/pages/NotFoundPage';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

// Guard: only allow logged-in admins through
function RequireAdmin({ children }) {
  const { currentUser, isAdmin, authLoading } = useAuth();
  const location = useLocation();

  if (authLoading) return null; // or a spinner

  if (!currentUser) {
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }
  if (!isAdmin()) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function App() {
  return (
    <LanguageProvider>
    <AuthProvider>
      <CartProvider>
        <div className="app-container">
          <Navbar />
          <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/recording" element={<RecordingPage />} />
        <Route path="/labs" element={<LabsPage />} />
        <Route path="/hire" element={<HirePage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/accommodation" element={<AccommodationPage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/order-success" element={<OrderSuccessPage />} />
        
        {/* Events dropdown routes */}
        <Route path="/music-events" element={<MusicEventsPage />} />
        <Route path="/food-events" element={<FoodEventsPage />} />
        <Route path="/upcoming" element={<UpcomingPage />} />
        <Route path="/archive" element={<ArchivePage />} />
        
        {/* Event detail route */}
        <Route path="/event/:id" element={<EventDetailPage />} />
        
        {/* Product detail route */}
        <Route path="/product/:id" element={<ProductDetailPage />} />

        {/* Contact route */}
        <Route path="/contact" element={<ContactPage />} />
        
        {/* Admin route */}
        <Route path="/admin" element={<RequireAdmin>
        <AdminPage />
      </RequireAdmin>} />
        <Route
    path="/ticket-validator"
    element={
      <RequireAdmin>
        <TicketValidatorPage />
      </RequireAdmin>
    }
  />
        <Route
    path="/ticket-test"
    element={
      <RequireAdmin>
        <TicketTestPage />
      </RequireAdmin>
    }
    />
          <Route path="/test-iframe" element={<TestIframePage />} />
          <Route path="/test-embed" element={<TestEmbedPage />} />
        {/* Admin setup route (for initial setup only) */}
        <Route
    path="/admin-setup"
    element={
      <RequireAdmin>
        <AdminSetup />
      </RequireAdmin>
    }
  />
        
        {/* Membership routes - TEMPORARILY HIDDEN */}
        {/* <Route path="/membership" element={<MembershipPage />} />
        <Route path="/membership/checkout" element={<MembershipCheckout />} />
        <Route path="/membership/success" element={<MembershipSuccess />} />
        <Route path="/member-dashboard" element={<MemberDashboard />} /> */}
        <Route path="/integritetspolicy" element={<PrivacyPolicyPage />} />
        <Route path="/kopvillkor" element={<TermsOfSalePage />} />
        <Route path="/cookies" element={<CookiesPage />} />
        
        {/* 404 catch-all route - must be last */}
        <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Footer />
        </div>
      </CartProvider>
    </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
